// Bausteine der Anmeldung für Anmeldeseite, öffentliche Seiten (Zurücksetzen, Einladung, Abmelden), Profil und
// Verwaltung – über '@api' erreichbar (docs/anmeldung/SPEZIFIKATION.md §10, §14.3 AP-W). Der Transport steht im Client
// (web/api/client.ts: loginMfa, mfaSetup, reauth …), die Formen in @shared/auth.
export { AuthFrame, authCard, type AuthFrameProps } from './AuthFrame'
export { CodeInput, isCompleteCode, sanitizeCode, type CodeInputProps, type CodeKind } from './CodeInput'
export { MfaSetup, type MfaSetupProps, type MfaSetupStart } from './MfaSetup'
export { displayRecoveryCode, RecoveryCodes, recoveryCodesText, type RecoveryCodesProps } from './RecoveryCodes'
export { TextAction, type TextActionProps } from './TextAction'
export { ReauthDialog, ReauthHost, useReauth, type Reauth, type ReauthDialogProps } from './Reauth'
export { requestReauth } from './reauthStore'
export {
  NewPasswordFields,
  PASSWORD_CHECK_DELAY_MS,
  PASSWORD_MISMATCH,
  usePasswordCheck,
  usePasswordMinLength,
  useResetTokenMinutes,
  type NewPasswordFieldsProps,
  type PasswordCheckState,
} from './PasswordFields'
export {
  codeFailureText,
  fieldMessage,
  isChallengeGone,
  isReauthRequired,
  loginChallengeOf,
  passwordFailureText,
  throttleText,
} from './errors'
export { readLinkToken, useLinkToken, withoutLinkToken, type LinkTokenOptions } from './linkToken'

/** Abschnitte von „Mein Profil“ (Sprungmarken) – Ziel der Sicherheitsleiste und der Hinweis-Mails (§5.7, §10.1, §10.2) */
export const PROFILE_PATH = '/settings/profile'
export const PROFILE_SECTIONS = {
  password: 'kennwort',
  mfa: 'zwei-faktor',
  devices: 'geraete',
  activity: 'sicherheitsaktivitaet',
  notifications: 'benachrichtigungen',
} as const
export type ProfileSection = keyof typeof PROFILE_SECTIONS
export const profileHref = (section: ProfileSection): string => `${PROFILE_PATH}#${PROFILE_SECTIONS[section]}`
